import { useContext, useCallback, useMemo } from "react"
import ListItemDropDown from "components/list-item-dropdown"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { INSTRUMENTS_WITH_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { buildModelCategoryOptions } from "connected-components/graph/helpers"
import { useCategorySync } from "connected-components/graph/hooks/use-category-sync"
import { PERFORMANCE_CONTEXT } from "./context"
import { GRAPH_CONTEXT_SHAPE } from "../../prop-types"

const BASIC_CATEGORIES = [
  { id: "total", primaryText: "Total" },
  { id: "factors", primaryText: "Factors" },
]

export default function GraphHeader({ modelMetadata, context }) {
  const { selectedCategory, setSelectedCategory, isPreferencesLoaded } = useContext(PERFORMANCE_CONTEXT)

  const categoryOptions = useMemo(
    () => buildModelCategoryOptions(modelMetadata, BASIC_CATEGORIES),
    [modelMetadata],
  )

  useCategorySync(categoryOptions, selectedCategory, setSelectedCategory, isPreferencesLoaded)

  const handleCategoryChange = useCallback((category) => {
    setSelectedCategory(category)
  }, [setSelectedCategory])

  return (
    <>
      <GraphTemplateSelector context={context} />
      <PeriodDisplay context={context} />
      <ListItemDropDown
        label="Category"
        value={selectedCategory}
        setValue={handleCategoryChange}
        options={categoryOptions}
        alignMenu="left"
        disablePortal
      />
    </>
  )
}

GraphHeader.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  context: GRAPH_CONTEXT_SHAPE.isRequired,
  instrumentsWithMetadata: INSTRUMENTS_WITH_METADATA_SHAPE.isRequired,
}
